var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.175,
    height: 11.166,
    viewBox: "0 0 13.175 11.166",
    fill: "#ea3943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_28",
    "data-name": "Union 28",
    d: "M6.882,10.874a1,1,0,0,1,0-1.41l3.88-3.88L6.892,1.7a1,1,0,0,1,1.4-1.42l4.59,4.59a1,1,0,0,1,0,1.41l-4.59,4.59a1,1,0,0,1-1.41,0Zm-6.59,0a1,1,0,0,1,0-1.41l3.88-3.88L.3,1.7A1,1,0,0,1,1.7.284l4.59,4.59a1,1,0,0,1,0,1.41L1.7,10.874a1,1,0,0,1-1.41,0Z",
    transform: "translate(13.175 11.166) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconClose);
export default __webpack_public_path__ + "static/media/sidebar_iconClose.1a8897bc11780ba6d55c2b9bd3f43e59.svg";
export { ForwardRef as ReactComponent };